<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-8 rounded-lg shadow-md w-96">
      <div v-if="loading" class="flex flex-col items-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-pdsPrimaryColor-500"></div>
      </div>
      <div v-if="error" class="text-center">
        <p class="mb-4">De patiënt is niet gevonden. Deze moet eerst worden aangemaakt in het Mediq systeem.</p>
        <button
            id="loginButton"
            @click="$router.push('/')"
            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pdsPrimaryColor hover:bg-pdsPrimaryColor/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pdsPrimaryColor disabled:opacity-50 disabled:cursor-not-allowed"
          >
          Terug naar Dashboard
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { isLoggedIn$ } from '@/services';
import store from '@/store';
export default {
  name: 'RedirectPage',
  props: {
    code: {
      type: String,
      required: true
    },
    clientId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      error: null
    }
  },
  computed: {
    baseUrl() {
      return window.location.origin;
    }
  },
  async created() {
    try {
      const { data } = await axios.get(`${this.baseUrl}/api/sitecore/v2/Nedap/GetPatientContext`, {
        params: {
          code: this.code,
          client_id: this.clientId
        }
      });

      let handled = false;
      if (data && typeof data === 'object' && data.PatientId && data.Token) {
        isLoggedIn$.subscribe((value) => {
          if (handled) {
            return;
          }

          handled = true;
          if (value) {
            localStorage.removeItem('nedapPendingResolve');
            localStorage.setItem('lastSelectedCustomer', data.PatientId);
            window.location.href = `${this.baseUrl}/patientdashboard`;
          } else {
            window.location.href = `${this.baseUrl}/inloggen?token=${data.Token}`;
          }
        });
      } else if (data && typeof data === 'object' && data.RequiresResolution && data.Token) {
        isLoggedIn$.subscribe(async (value) => {
          if (handled) {
            return;
          }

          handled = true;
          if (value) {
            await this.resolvePatientContext();
          } else {
            localStorage.setItem(
              'nedapPendingResolve',
              JSON.stringify({
                code: this.code,
                clientId: this.clientId
              })
            );
            window.location.href = `${this.baseUrl}/inloggen?token=${data.Token}`;
          }
        });
      } else {
        this.error = true;
        this.loading = false;
      }
    } catch (err) {
      this.error = true;
      this.loading = false;
      console.error('Redirect error:', err);
    }
  },
  methods: {
    async resolvePatientContext() {
      try {
        const storedDepartment = window.localStorage.getItem('lastSelectedDepartment');
        if (storedDepartment) {
          await store.dispatch('login/selectedDepartmentChange', storedDepartment);
        }

        const { data } = await axios.get(`${this.baseUrl}/api/sitecore/v2/Nedap/ResolvePatientContext`, {
          params: {
            code: this.code,
            client_id: this.clientId
          }
        });

        localStorage.removeItem('nedapPendingResolve');
        localStorage.removeItem('tokenlogin');

        if (data && typeof data === 'object' && data.PatientId) {
          localStorage.setItem('lastSelectedCustomer', data.PatientId);
          window.location.href = `${this.baseUrl}/patientdashboard`;
          return;
        }

        if (data && typeof data === 'object' && data.RequiresPatientCompletion) {
          const patientSearchArguments = data.PatientSearchArguments || this.buildPatientSearchArguments(data.PatientPrefill);
          if (data.PatientPrefill) {
            localStorage.setItem('nedapPatientPrefill', JSON.stringify(data.PatientPrefill));
          } else {
            localStorage.removeItem('nedapPatientPrefill');
          }
          if (patientSearchArguments) {
            store.commit('search/setPatientSearchArguments', patientSearchArguments);
          }
          await store.dispatch('patient/setEndpoints', 'new');
          await this.navigateToPatientDetails();
          return;
        }

        this.error = true;
        this.loading = false;
      } catch (err) {
        this.error = true;
        this.loading = false;
        console.error('Resolve patient context error:', err);
      }
    },
    buildPatientSearchArguments(patientPrefill) {
      if (!patientPrefill || !patientPrefill.BSNnummer) {
        return null;
      }

      return {
        searchOptions: 'BSN',
        dateOfBirth: patientPrefill.GeboorteDatum || null,
        bsn: patientPrefill.BSNnummer
      };
    },
    async navigateToPatientDetails() {
      try {
        await this.$router.push({ name: 'patientgegevens' });
      } catch (error) {
        window.location.href = `${this.baseUrl}/patientgegevens`;
      }
    },
    hasValidAspNetCookie() {
      const cookies = document.cookie.split(';');
      const aspNetCookie = cookies.find(cookie => cookie.trim().indexOf('.AspNet.cookie') !== -1);

      if (!aspNetCookie) return false;
      return true;
    }
  },
}
</script>

